// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.App {
  text-align: center;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
}

.content {
  flex-grow: 1;
  width: 100%;
  padding-bottom: 100px;
}

.wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

footer {
  background: #A7C898;
  padding: 30px 20px;
  text-align: center;
  width: 100%;
  height: 230px;
}

/* 작은 화면에 대한 스타일 */
@media screen and (max-height: 600px) {
  html, body {
    width: 100%; /* 최소 높이 고정 */
  }
}

.content{
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE;IACE,WAAW,EAAE,aAAa;EAC5B;AACF;;AAEA;EACE,WAAW;AACb","sourcesContent":["html, body {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.App {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n.content {\n  flex-grow: 1;\n  width: 100%;\n  padding-bottom: 100px;\n}\n\n.wrapper {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\nfooter {\n  background: #A7C898;\n  padding: 30px 20px;\n  text-align: center;\n  width: 100%;\n  height: 230px;\n}\n\n/* 작은 화면에 대한 스타일 */\n@media screen and (max-height: 600px) {\n  html, body {\n    width: 100%; /* 최소 높이 고정 */\n  }\n}\n\n.content{\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
